<button
  *ngIf="!linkText; else menuLinkButton"
  df-button
  dfButtonType="primary"
  [dgxPopoverTrigger]="addItemsPopover"
  class="add-content-button l_flex--align-right"
  data-dgat="add-menu-fef"
  (click)="setFocus()"
  [attr.aria-label]="ariaLabel"
>
  <div class="l_flexbar gap-full-half">
    <df-icon icon="plus"></df-icon>
    <div>{{ i18n.Core_Add }}</div>
  </div>
</button>

<ng-template #menuLinkButton>
  <button
    df-button
    dfButtonType="clear"
    class="add-btn guts-p-full-0 link uhover"
    data-dgat="add-menu-f8e"
    [dgxPopoverTrigger]="addItemsPopover"
    (click)="setFocus()"
  >
    <df-icon icon="plus-circle" size="large" class="add-btn__icon"> </df-icon>
    <span class="par par--small l_flex-center font-bold add-btn__text">
      {{ linkText | translate }}
    </span>
  </button>
</ng-template>

<dgx-popover
  #addItemsPopover
  [popoverArrowHidden]="true"
  placement="bottom-right"
>
  <div class="guts-p-h-2 guts-p-v-1-half sorting-popover">
    <ul>
      <li
        *ngFor="let item of menuConfig; let last = last"
        [class.guts-m-b-1]="!last"
        data-dgat="profile-collection-fc5"
      >
        <button
          df-button
          dfButtonType="clear"
          (click)="item.defaultAction($event)"
          data-dgat="profile-collection-2b7"
        >
          <span class="par par--small par--light_a font-semibold">{{
            item.title
          }}</span>
        </button>
      </li>
    </ul>
  </div>
</dgx-popover>
